/* React Higher Order Component which fetches activity version validation data for activity where activityId = props.activityId.
    Child (InnerComponent) will only render once activity data is successfully fetched.
    child will receive props: {
        validationObj: PropTypes.object
    }
*/

import React from 'react';
import PropTypes from 'prop-types';

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const ReactUtil = require('../../util/ReactUtil');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    version: PropTypes.string.isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
    projectStoreState: PropTypes.shape({ project: PropTypes.shape({ user_permissions: PropTypes.object.isRequired }) }).isRequired,
};

const defaultProps = {
};


export default function withActivityVersionValidationData(WrappedComponent) {
    class WithActivityVersionValidationData extends React.Component {
        constructor(props) {
            super(props);

            this.getValidationObjFromStore = this.getValidationObjFromStore.bind(this);

            this.state = {
                validationObj: this.getValidationObjFromStore(
                    ActivityStore.getStateActivity(
                        props.activityId,
                        props.projectStoreState.project.id,
                        props.channelStoreState.channel.id
                    ),
                    props.version
                ),
                fatalError: null
            };

            this.getValidationObj = this.getValidationObj.bind(this);
            this.unsubscribes = [ActivityStore.listen(this.onActivityStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
            this.getValidationObj();
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(unsubscribeCallback => unsubscribeCallback());
        }

        onActivityStoreChange(newState) {
            if (!newState.action || newState.action.id !== `get-validation-${this.props.activityId}-${this.props.version}`) {
                return;
            }

            const self = this;
            let updatedState = {};

            if (newState.action.error) {
                updatedState = { ...updatedState, fatalError: newState.action.error };
            }
            else {
                const validationObj = this.getValidationObjFromStore(
                    ActivityStore.getStateActivity(
                        this.props.activityId,
                        this.props.projectStoreState.project.id,
                        this.props.channelStoreState.channel.id
                    ),
                    this.props.version
                )
                updatedState = { ...updatedState, validationObj: validationObj };
            }

            this.setState(updatedState);
        }

        getValidationObjFromStore(state, version) {
            return !!state && !!state.actVersionsValidation && !!state.actVersionsValidation[version] ?
                state.actVersionsValidation[version]
                :
                null;
        }

        getValidationObj() {
            const project = this.props.projectStoreState.project;
            const channel = this.props.channelStoreState.channel;
            if (
                !project 
                || !channel 
                || !PermissionsUtil.canViewValidationReport(channel.user_permissions, project.user_permissions)
            ) {
                return;
            }

            ActivityActions.getValidationForVersion(
                `get-validation-${this.props.activityId}-${this.props.version}`,
                { activityId: this.props.activityId, version: this.props.version }
            );
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace={false}/>;
            }

            if (!this.state.validationObj) {
                return null;
            }

            return (
                <WrappedComponent
                    {...this.props}
                    validationObj={this.state.validationObj}
                />
            );
        }
    }

    WithActivityVersionValidationData.propTypes = propTypes;
    WithActivityVersionValidationData.defaultProps = defaultProps;
    WithActivityVersionValidationData.displayName = `WithActivityVersionValidationData(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithActivityVersionValidationData;
}
